export default __webpack_public_path__ + "maps-examples-clustering-with-images-thumbnail-960-9f5122596d96e6a1478f604aba654f2d.webp";